(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nekoneko-support"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('neko-support')) {
    customElements.define('neko-support', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        try { this.config = JSON.parse(this.querySelector('[data-neko-support-config]').textContent); } catch { return; }
        if (!this.config.strings || typeof this.config.strings !== 'object') return;
        this.ready = true;
        this.strings = this.config.strings;
        this.launcher = this.querySelector('.neko-support__launcher');
        this.panel = this.querySelector('.neko-support__panel');
        this.messages = this.querySelector('.neko-support__messages');
        this.input = this.querySelector('input');
        this.launcher.addEventListener('click', () => this.toggle(this.panel.hidden));
        this.querySelector('.neko-support__close').addEventListener('click', () => this.toggle(false));
        this.addEventListener('keydown', event => { if (event.key === 'Escape' && !this.panel.hidden) { event.stopPropagation(); this.toggle(false); } });
        this.querySelectorAll('[data-topic]').forEach(button => button.addEventListener('click', () => this.respond(button.dataset.topic, button.textContent)));
        this.querySelector('form').addEventListener('submit', event => {
          event.preventDefault();
          const question = this.input.value.trim().slice(0, 300);
          if (!question) return;
          this.input.value = '';
          this.addMessage(question, true);
          this.match(question).forEach(topic => this.answer(topic));
          this.input.focus({ preventScroll: true });
        });
        this.hidden = false;
      }
      toggle(open) {
        this.panel.hidden = !open;
        this.launcher.setAttribute('aria-expanded', String(open));
        (open ? this.input : this.launcher).focus({ preventScroll: true });
      }
      addMessage(text, customer = false, links = []) {
        const bubble = document.createElement('div');
        bubble.className = 'neko-support__message' + (customer ? ' neko-support__message--customer' : '');
        bubble.textContent = text;
        links.forEach(([label, href]) => { const a = document.createElement('a'); a.textContent = label; a.href = href; bubble.append(a); });
        this.messages.append(bubble);
        while (this.messages.children.length > 40) this.messages.firstElementChild.remove();
        this.messages.scrollTop = this.messages.scrollHeight;
      }
      respond(topic, question) { this.addMessage(question, true); this.answer(topic); }
      match(question) {
        const tests = [
          ['tracking', /\b(track|tracking|order|cancel|address|parcel)\b|订单|物流|取消/iu],
          ['returns', /\b(return|returns|refund|refunds|exchange|damaged|defective|wrong item)\b|退货|退款|破损/iu],
          ['shipping', /\b(shipping|ship|postage|customs|duties|tax|taxes|free delivery)\b|包邮|运费|关税/iu],
          ['delivery', /\b(delivery|arrive|arrival|when|long|days|deadline|convention)\b|多久|到货|时效/iu],
          ['size', /\b(size|sizing|fit|fitting|head|circumference|measurement|measurements|cap)\b|尺寸|头围|大小/iu],
          ['price', /\b(price|prices|cost|costs|much|discount|coupon|currency|payment|pay|paypal|card)\b|价格|多少钱|支付|优惠/iu],
          ['care', /\b(heat|temperature|curl|curling|straightener|style|styling|care|wash|washing|trim|accessories|included)\b|保养|耐热|温度|造型|配件/iu],
          ['tier', /\b(ssr|sr|tier|quality)\b|档位|质量/iu]
        ];
        const topics = tests.filter(([, pattern]) => pattern.test(question)).map(([topic]) => topic);
        if (topics.length) return topics.slice(0, 3);
        return [/^(hi|hello|hey|thanks|thank you|你好|谢谢)[! .♡]*$/iu.test(question) ? 'greeting' : 'fallback'];
      }
      answer(topic) {
        const s = this.strings, l = this.config.links;
        const links = { shipping: [[s.shipping_link, l.shipping]], delivery: [[s.shipping_link, l.shipping]], returns: [[s.returns_link, l.returns]], care: [[s.faq, l.faq]], price: [[s.browse, l.browse]], fallback: [[s.contact, '/pages/contact']] };
        let text = s[topic + '_answer'] || s[topic] || s.fallback;
        if (topic === 'price') text = (this.config.productPrice ? s.product_price + ' ' + this.config.productPrice + '\n' + s.price_note : s.price_general) + '\n' + s.payment_answer;
        this.addMessage(text, false, links[topic] || []);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (() => {
  const pending = [];
  const requests = new Map();
  let active = 0;
  const pump = () => {
    while (active < 3 && pending.length) {
      active += 1;
      const job = pending.shift();
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 8000);
      fetch('/apps/views-count-dev/product', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        signal: controller.signal,
        body: JSON.stringify({
          storeId: job.card.dataset.viewsStore,
          productId: job.card.dataset.viewsProduct,
          productHandle: job.card.dataset.viewsHandle,
          vcbToken: false,
          preview: true
        })
      }).then(response => response.ok ? response.json() : null)
        .then(job.resolve, () => job.resolve(null))
        .finally(() => {
          clearTimeout(timeout);
          active -= 1;
          pump();
        });
    }
  };
  const load = card => {
    const id = card.dataset.viewsProduct;
    if (!requests.has(id)) {
      requests.set(id, new Promise(resolve => {
        pending.push({ card, resolve });
        pump();
      }));
    }
    requests.get(id).then(data => {
      const meter = card.querySelector('[data-card-views]');
      if (!meter || !data || data.success !== true || !data.settings) return;
      const count = data.settings.viewsType === 'unique' ? data.visitors : data.count;
      if (!Number.isSafeInteger(count) || count <= 0) return;
      const label = data.settings.text;
      const before = data.settings.textBefore;
      if (typeof label !== 'string') return;
      meter.textContent = [typeof before === 'string' ? before : '', String(count), label].filter(Boolean).join(' ');
      meter.style.display = 'block';
      meter.style.visibility = 'visible';
      meter.removeAttribute('aria-hidden');
    });
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        observer.unobserve(entry.target);
        load(entry.target);
      }
    });
  }, { rootMargin: '120px' }) : null;
  const init = root => {
    const cards = [];
    if (root.matches?.('[data-views-product]')) cards.push(root);
    cards.push(...root.querySelectorAll('[data-views-product]'));
    cards.forEach(card => {
      if (card.dataset.viewsReady) return;
      card.dataset.viewsReady = 'true';
      if (observer) observer.observe(card);
      else load(card);
    });
  };
  const start = () => {
    init(document);
    const main = document.getElementById('MainContent');
    if (main) new MutationObserver(changes => {
      changes.forEach(change => change.addedNodes.forEach(node => {
        if (node.nodeType === Node.ELEMENT_NODE) init(node);
      }));
    }).observe(main, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
